import { render } from "./LockRateModal.vue?vue&type=template&id=3c8e552e"
import script from "./LockRateModal.vue?vue&type=script&lang=js"
export * from "./LockRateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__